module.exports = __webpack_public_path__ + "img/6.64b9ea6d.png";